{
  "code": "Waehere pāhono",
  "error": {
    "details": "<ul>  \n<li>Tirohia mēnā he hapa tāu, ā, ngana anō.</li>  \n<li>Mēnā kei te raru koe, waea mai ki a mātou: {{phone}} (pāwhiritia te Kōwhiringa 2).</li>  \n</ul>",
    "title": "Kāore taua waehere pāhono i mahi"
  },
  "helpMessage": "<p>Kua ngaro tō pāhono, kāore rānei koe i te mōhio me aha?<br />Waea mai ki a mātou i <a><strong>{{phone}}</strong></a> (ka pēhi i te <strong>Kōwhiringa 2</strong>).</p>",
  "text": "<p>Whakaurua tō waehere pāhono 6-ā-ira hei tīmatanga.</p><p>Ka kitea tēnei waehere i tō īmēra pāhono, i tukuna rānei e te tangata nāna koe i tuku mai.</p>",
  "title": "Tuwhera i tō pāhono whakaritenga"
}
